module.exports = __webpack_public_path__ + "img/lun.4ebb9983.jpg";